import { render, staticRenderFns } from "./ClassifiedProducts.vue?vue&type=template&id=1f52b6f7&scoped=true"
import script from "./ClassifiedProducts.vue?vue&type=script&lang=js"
export * from "./ClassifiedProducts.vue?vue&type=script&lang=js"
import style0 from "./ClassifiedProducts.vue?vue&type=style&index=0&id=1f52b6f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f52b6f7",
  null
  
)

export default component.exports